const obj = {
  primary: '#00D392',
};

export default obj;
